import contractTypeAllComponent from './contract_type.all.component';

let contractTypeAllModule = angular.module('contractTypeAll', [])

    .component('contractTypeAll', contractTypeAllComponent)

    .name;

export default contractTypeAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/all/index.js